
$(function () { /* query ready function */

    // /Profile/Edit
    if ($(".edit-profile-page").length > 0) {

        $('#pre').editableSelect({ filter: false });
        $('#pre').on('select.editable-select', function (e, $element) {
            e.preventDefault();
            $("#Prefix").val($element.data('val'));
        });
        $(document).on('keyup', '#pre', function (e, $element) {
            e.preventDefault();
            $("#Prefix").val($('#pre').val());
        });
        if ($("#Prefix").val() === "") {
            $("#pre").text("");
        }

        $("li.district").hover(function () {
            $(".dimg").hide();
            $("." + $(this).data('district')).show();
        }, function () {
            $(".dimg").hide();
            $(".blank").show();
        });

        $("li.district i, li.district span").on(window.app.clickEvent, function () {
            console.log();
            $("#districtModalTitle").html($(this).data("title"));
            $(".district-modal-body img").prop("src", $("." + $(this).closest("li").data('district')).prop("src"));
            $("#districtsModal").modal();
        });
    }

});